// Auth headers for taurus-api GraphQL requests (WHIT-339). The ID token is
// fetched per request: getIdToken() returns Firebase's cached token while it
// is valid and refreshes it once expired. A copy kept in React state goes
// stale after an hour in a sleeping tab, and the API then rejects it with
// auth/id-token-expired. Plain CommonJS so `node --test` can run the tests.

// If the refresh fails (offline, disabled account) the request is still sent,
// without a token: the API refuses it and the caller's error handling runs,
// rather than an exception escaping before the request is made.
const freshIdToken = async user => {
  if (!user) return null;
  try {
    return await user.getIdToken();
  } catch {
    return null;
  }
};

// `user` is the signed-in Firebase User, or null.
const authHeaders = async user => ({
  authtoken: await freshIdToken(user),
  uid: user?.uid || null,
  isAnonymous: user?.isAnonymous,
});

module.exports = { authHeaders };
